var _path;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgIconAdd = function SvgIconAdd(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.001,
    height: 20,
    viewBox: "0 0 20.001 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M1284,105a10,10,0,1,1,10,10A10,10,0,0,1,1284,105Zm10,8a8,8,0,1,0-8-8A8.01,8.01,0,0,0,1294,113Zm-1-5v-2h-2a1,1,0,0,1,0-2h2v-2a1,1,0,1,1,2,0v2h2a1,1,0,0,1,0,2h-2v2a1,1,0,1,1-2,0Z",
    transform: "translate(-1283.999 -95)",
    fill: "#b3bccf"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAdd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_add.5ae17e88.svg";
export { ForwardRef as ReactComponent };